import React, { useEffect, useState } from "react";
import { getCertificate, reGenerateCertificate } from "../../../../../Api/apiUtils";
import { AiFillSafetyCertificate } from "react-icons/ai";
import { toast } from "react-toastify";
import { Button, EmptyState } from "../../../../../ui";
import { Actions, Callout, Dialog } from "../ui-pending";
import "./certificate.scss";


interface CertificateProps {
  profileData: any;
  courseId: number;
}

const CourseCertificate: React.FC<CertificateProps> = ({ profileData, courseId }) => {
  const userId = profileData?.studentUserId;
  console.log("Course ID in Certificate Component:", profileData);
  const [certificateData, setCertificateData] = useState<any>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCert, setSelectedCert] = useState<any>(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);



  useEffect(() => {
    if (userId ) {
      getCertificate(userId, courseId)
        .then((response) => {
          setCertificateData(response);
        //   console.log("Certificate:", response?.data);
        })
        .catch((err) => {
          console.error("Certificate fetch failed:", err);
        });
    }
  }, [courseId, userId]);

  const handleReGenerate = () => {
    setConfirmModalOpen(true); // Open the confirmation modal


    const payload = {
     "userId": userId,
     "userName": profileData.studentName,
     "courseId": courseId,
    };
    
    if (!userId) return;
    setLoading(true);
    reGenerateCertificate(payload)

      .then((response) => {
        toast.success("Generated Successfully");
        setConfirmModalOpen(false);
        setLoading(false);

        return getCertificate(userId, courseId);
      })
      .catch((err) => {
        toast.error("Certificate regeneration failed:", err);
        setLoading(false);
        // alert("Failed to regenerate certificate. Please try again later.");
      });
  };

  // Helper to format date
  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const certificates = certificateData?.certificates || [];

  return (
    <div className="ds-stack certificates">
      {certificates.length !== 0 && (
        <Actions align="start">
          <Button
            variant="primary"
            onClick={() => setConfirmModalOpen(true)} // Correctly toggle the modal
          >
            Regenerate Certificates
          </Button>
        </Actions>
      )}
      {certificates.length === 0 && (
        <EmptyState
          title="No certificates found"
          description="Certificates appear here once the student completes a level in this course."
        />
      )}
      {certificates.length !== 0 && (
        <ul className="certificates__grid">
          {certificates.map((cert: any) => (
            <li key={cert.id} className="certificates__item">
              <span className="certificates__course ds-text-subtle">
                {cert.course_name} - {cert.level_name}
              </span>
              <button
                type="button"
                className="certificates__tile"
                onClick={() => {
                  setSelectedCert(cert);
                  setModalOpen(true);
                }}
              >
                <span className="certificates__tile-text">
                  <span className="certificates__title">Completion Certificate</span>
                  <span className="certificates__received">received</span>
                  <span className="certificates__date ds-text-muted">{formatDate(cert.date)}</span>
                </span>
                <AiFillSafetyCertificate size={32} className="certificates__icon" aria-hidden />
              </button>
            </li>
          ))}
        </ul>
      )}
      <Dialog
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        size="lg"
        title={selectedCert ? `${selectedCert.course_name} - ${selectedCert.level_name}` : "Certificate"}
      >
        <div className="certificates__preview">
          {selectedCert && selectedCert.certificate_url ? (
            <img
              src={`${selectedCert.certificate_url}?v=${Date.now()}`}
              alt="Certificate"
              className="certificates__image"
            />
          ) : (
            <EmptyState title="No certificate image available" />
          )}
        </div>
      </Dialog>
      {/* Confirmation dialog */}
      <Dialog
        isOpen={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        title="Confirm Certificate Regeneration"
        actions={
          <>
            <Button variant="secondary" onClick={() => setConfirmModalOpen(false)}>
              Cancel
            </Button>
            <Button variant="primary" disabled={loading} loading={loading} onClick={handleReGenerate}>
              {loading ? "Regenerating..." : "Confirm & Regenerate"}
            </Button>
          </>
        }
      >
        <div className="ds-stack">
          <p className="certificates__confirm">
            Please confirm your name for the certificate: <span className="ds-strong">{profileData.studentName}</span>
          </p>
          <Callout tone="warning">If the name is incorrect, please update it in the profile section.</Callout>
        </div>
      </Dialog>
    </div>
  );
};

export default CourseCertificate;
